import CheckMarkIcon from "../../public/checkMark.svg?react";
import InfoIcon from "../../public/info.svg?react";
import { useTranslation } from "../i18n";

/**
 * @param {object} args
 * @param {string} args.title
 * @param {number | null} args.amount
 * @param {string} args.description
 * @param {boolean} args.isActive
 * @param {() => void} args.setActive
 * @returns {React.Component}
 */
const DiscountCard = ({ title, amount, description, isActive, setActive }) => {
  return (
    <div
      className={`cursor-pointer p-4 rounded-lg relative ${isActive ? "bg-accent" : "bg-c-gray-500 "}`}
      onClick={setActive}
    >
      <p className="mb-4">{title}</p>
      <h1 className="">{amount != null ? amount * 100 : ""}%</h1>
      <CheckMarkIcon
        className={`absolute top-0 right-0 m-2 h-4 w-auto ${isActive ? "" : "hidden"}`}
      />
      <div className="group">
        <InfoIcon
          className="absolute bottom-0 right-0 p-2 h-8 w-auto"
          onClick={() => alert(description)}
        />
        <p className="absolute bg-[#364560] rounded-lg  p-4 hidden group-hover:block bottom-10 -right-">
          {description}
        </p>
      </div>
    </div>
  );
};

/**
 * @param {object} args
 * @param {Array<FlexibleDiscount>} args.discounts
 * @param {number} args.activeIdx
 * @param {(idx: number) => void} args.setActiveIdx
 * @param {boolean} args.hasAutoDiscount
 * @returns {React.Component}
 */
const FlexibleDiscount = ({
  discounts,
  setActiveIdx,
  activeIdx,
  hasAutoDiscount,
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-4 p-4 grid-cols-3 w-full">
      {discounts.map((d, idx) => (
        <DiscountCard
          key={d.name}
          title={d.name}
          amount={d.amount}
          description={d.description}
          isActive={activeIdx === idx}
          setActive={() => {
            if (idx === activeIdx) {
              setActiveIdx(null);
            } else {
              setActiveIdx(idx);
            }
          }}
        />
      ))}
      {hasAutoDiscount && (
        <DiscountCard
          title={t("flexibleDiscount.autoDiscount")}
          amount={null}
          description=""
          isActive={activeIdx == null}
          setActive={() => setActiveIdx(null)}
        />
      )}
    </div>
  );
};

export default FlexibleDiscount;
